var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container-sitc",
      staticStyle: { "padding-bottom": "0px" },
    },
    [
      _c("div", { staticClass: "filter-container-content" }, [
        _c(
          "div",
          { staticClass: "filter-container-new" },
          [
            _c(
              "el-form",
              {
                ref: "listQuery",
                attrs: {
                  model: _vm.listQuery,
                  "label-position": "top",
                  "label-width": "100px",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 14 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("home.vesselAndVoyage") + "：",
                              prop: "pol",
                            },
                          },
                          [
                            _c("gl-ship-voyage", {
                              on: {
                                handleOpenVessel: _vm.handleOpenVesselSearch,
                              },
                              model: {
                                value: _vm.listQuery,
                                callback: function ($$v) {
                                  _vm.listQuery = $$v
                                },
                                expression: "listQuery",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("home.pol") + "：",
                              prop: "pol",
                            },
                          },
                          [
                            _c("glPort", {
                              model: {
                                value: _vm.listQuery.pol,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listQuery, "pol", $$v)
                                },
                                expression: "listQuery.pol",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("home.pod") + "：",
                              prop: "pod",
                            },
                          },
                          [
                            _c("glPort", {
                              model: {
                                value: _vm.listQuery.pod,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listQuery, "pod", $$v)
                                },
                                expression: "listQuery.pod",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "pot" } },
                          [
                            _c(
                              "el-radio",
                              {
                                attrs: { label: "1" },
                                on: { change: _vm.changeTime },
                                model: {
                                  value: _vm.radio,
                                  callback: function ($$v) {
                                    _vm.radio = $$v
                                  },
                                  expression: "radio",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("home.sailingTime")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-radio",
                              {
                                attrs: { label: "2" },
                                on: { change: _vm.changeTime },
                                model: {
                                  value: _vm.radio,
                                  callback: function ($$v) {
                                    _vm.radio = $$v
                                  },
                                  expression: "radio",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("home.createTime")))]
                            ),
                            _vm._v(" "),
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                format: "yyyy-MM-dd",
                                "picker-options": _vm.pickerOptions,
                                "unlink-panels": true,
                                "range-separator": _vm.$t("home.form"),
                                "start-placeholder": _vm.$t("home.startTime"),
                                "end-placeholder": _vm.$t("home.endTime"),
                              },
                              on: { change: _vm.handleChangeTime },
                              model: {
                                value: _vm.dataTime,
                                callback: function ($$v) {
                                  _vm.dataTime = $$v
                                },
                                expression: "dataTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 14 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("home.bkNo") + "：",
                              prop: "bkNo",
                            },
                          },
                          [
                            _c("ClearableTextInput", {
                              attrs: {
                                values: _vm.listQuery.bkNo,
                                maxlength: "500",
                              },
                              model: {
                                value: _vm.listQuery.bkNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listQuery, "bkNo", $$v)
                                },
                                expression: "listQuery.bkNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("home.blNo") + "：",
                              prop: "blNo",
                            },
                          },
                          [
                            _c("ClearableTextInput", {
                              attrs: {
                                values: _vm.listQuery.blNo,
                                maxlength: "500",
                              },
                              model: {
                                value: _vm.listQuery.blNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listQuery, "blNo", $$v)
                                },
                                expression: "listQuery.blNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "status",
                              label: _vm.$t("home.bookingStatus") + "：",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { multiple: "", clearable: "" },
                                model: {
                                  value: _vm.listQuery.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.listQuery, "status", $$v)
                                  },
                                  expression: "listQuery.status",
                                },
                              },
                              _vm._l(_vm.bookingList, function (item) {
                                return _c("el-option", {
                                  key: item.codeValue,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.displayValueCn
                                        : item.displayValue,
                                    value: item.codeValue,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("home.remark") + "：",
                              prop: "remark",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { type: "text", clearable: "" },
                              model: {
                                value: _vm.listQuery.remark,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listQuery, "remark", $$v)
                                },
                                expression: "listQuery.remark",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 14 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("el-form-item", {
                          staticClass: "reqired",
                          attrs: { label: _vm.$t("home.bkNoMultiple") },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("el-form-item", {
                          staticClass: "reqired",
                          attrs: { label: _vm.$t("home.blNoMultiple") },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      {
                        staticStyle: { "text-align": "right" },
                        attrs: { span: 12 },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            staticStyle: { "margin-left": "20px" },
                            attrs: { type: "primary" },
                            on: { click: _vm.handleSearchSelect },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("home.search")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-plain-primary",
                            on: { click: _vm.handleReset },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.reset")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            attrs: { type: "primary" },
                            on: { click: _vm.handleExportExcel },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.exportTitle")))]
                        ),
                        _vm._v(" "),
                        !_vm.isShow
                          ? _c(
                              "i",
                              {
                                staticClass: "el-icon-s-operation fontSize",
                                staticStyle: { display: "contents" },
                                on: { click: _vm.handleShow },
                              },
                              [_vm._v(_vm._s(_vm.$t("home.listModel")))]
                            )
                          : _c(
                              "i",
                              {
                                staticClass: "el-icon-s-grid fontSize",
                                staticStyle: { display: "contents" },
                                on: { click: _vm.handleShow },
                              },
                              [_vm._v(_vm._s(_vm.$t("home.cardModel")))]
                            ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "filter-container-content",
          staticStyle: { "margin-bottom": "0px" },
        },
        [
          _c(
            "div",
            { staticClass: "icon-box" },
            [
              _c(
                "el-button",
                {
                  staticClass: "el-icon-printer icon-box-margin-button",
                  attrs: { disabled: _vm.printFlag },
                  on: { click: _vm.handlePrint },
                },
                [_vm._v("Print B/L")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "el-icon-view icon-box-margin-button",
                  on: {
                    click: function ($event) {
                      return _vm.goToPath("/topMenu/equipmentFee")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("home.bookMySeven")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "el-icon-time icon-box-margin-button",
                  on: { click: _vm.handleGoCutTime },
                },
                [_vm._v(_vm._s(_vm.$t("home.bookMyThree")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "el-icon-tickets icon-box-margin-button",
                  on: { click: _vm.handleImport },
                },
                [_vm._v(_vm._s(_vm.$t("home.bookMyFour")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "icon icondaoru icon-box-margin-button",
                  on: { click: _vm.handleImportVgm },
                },
                [_vm._v(_vm._s(_vm.$t("home.bookMySix")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass:
                    "el-icon-document-checked icon-box-margin-button",
                  on: { click: _vm.handleOpenCheck },
                },
                [_vm._v(_vm._s(_vm.$t("home.bookMyEight")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "el-icon-s-operation icon-box-margin-button",
                  on: { click: _vm.handleAdjustVessel },
                },
                [_vm._v(_vm._s(_vm.$t("home.bookMyTwo")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "el-icon-s-check icon-box-margin-button",
                  on: { click: _vm.handleGoApply },
                },
                [_vm._v(_vm._s(_vm.$t("home.bookMyOne")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "el-icon-setting icon-box-margin-button",
                  on: {
                    click: function ($event) {
                      return _vm.goToPath("/topMenu/cargoTrack")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("home.bookMyNine")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "el-icon-setting icon-box-margin-button",
                  on: { click: _vm.handleOpenNewReportCombined },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("booking.bookingSplit.spliteCombinType1"))
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "el-icon-reading icon-box-margin-button",
                  on: { click: _vm.handleOpenNewReportTable },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("booking.bookingSplit.spliteCombinType0"))
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "el-icon-document-delete icon-box-margin-button",
                  on: { click: _vm.saveCancelBookingHeadWebComList },
                },
                [_vm._v(_vm._s(_vm.$t("home.bookCancel")))]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "el-icon-folder-checked icon-box-margin-button",
                  on: { click: _vm.handleBatchCommit },
                },
                [_vm._v(_vm._s(_vm.$t("home.batchCommit")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isShow
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoading,
                      expression: "tableLoading",
                    },
                  ],
                  staticClass: "table-container-new",
                },
                [
                  _c(
                    "el-table",
                    {
                      key: _vm.tableKey,
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.tableData,
                        border: "",
                        height: "calc(100vh - 417px)",
                        "row-class-name": _vm.tableRowClassName,
                      },
                      on: { "selection-change": _vm.handleSelectionChange },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { fixed: "", type: "selection", width: "55" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          index: _vm.indexMethod,
                          label: _vm.$t("home.No"),
                          width: "60",
                        },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.sourceData, function (column, index) {
                        return [
                          column.prop === "status"
                            ? _c("el-table-column", {
                                key: index,
                                attrs: {
                                  sortable: column.sortable,
                                  "min-width": column.width,
                                  "show-overflow-tooltip":
                                    column.showOverflowTooltip,
                                  label: column.label,
                                  prop: column.prop,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(scope.row.sailingTime)
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("bookingStatus", {
                                            staticClass: "main-status",
                                            attrs: {
                                              bookingList: _vm.bookingList,
                                              status: scope.row.status,
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : column.prop === "portOfDeparture"
                            ? _c(
                                "el-table-column",
                                {
                                  key: index,
                                  attrs: {
                                    sortable: column.sortable,
                                    "show-overflow-tooltip":
                                      column.showOverflowTooltip,
                                    width: column.width,
                                    label: column.label,
                                    prop: column.prop,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "vertical-align": "super",
                                                },
                                              },
                                              [_vm._v(_vm._s(scope.row.pol))]
                                            ),
                                            _vm._v(" "),
                                            _c("img", {
                                              staticStyle: {
                                                width: "30px",
                                                height: "20px",
                                              },
                                              attrs: {
                                                src: require("@/assets/img/youjiantou_black.png"),
                                                alt: "",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "vertical-align": "super",
                                                },
                                              },
                                              [_vm._v(_vm._s(scope.row.pod))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c("template", { slot: "header" }, [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("home.pol"))),
                                    ]),
                                    _vm._v(" "),
                                    _c("img", {
                                      staticStyle: {
                                        width: "30px",
                                        height: "20px",
                                        "vertical-align": "middle",
                                      },
                                      attrs: {
                                        src: require("@/assets/img/youjiantou.png"),
                                        alt: "",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("home.pod"))),
                                    ]),
                                  ]),
                                ],
                                2
                              )
                            : column.prop === "voyageNo"
                            ? _c("el-table-column", {
                                key: index,
                                attrs: {
                                  sortable: column.sortable,
                                  "show-overflow-tooltip":
                                    column.showOverflowTooltip,
                                  width: column.width,
                                  label: column.label,
                                  prop: column.prop,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(scope.row.voyageNo) +
                                                _vm._s(scope.row.voyageLeg)
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : column.prop === "latestEtdPol"
                            ? _c("el-table-column", {
                                key: index,
                                attrs: {
                                  sortable: column.sortable,
                                  "show-overflow-tooltip":
                                    column.showOverflowTooltip,
                                  width: column.width,
                                  label: column.label,
                                  prop: column.prop,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.parseTime(
                                                  scope.row.latestEtdPol,
                                                  "{y}-{m}-{d} "
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : column.prop === "vgm"
                            ? _c("el-table-column", {
                                key: index,
                                attrs: {
                                  sortable: column.sortable,
                                  "show-overflow-tooltip":
                                    column.showOverflowTooltip,
                                  width: column.width,
                                  label: column.label,
                                  prop: column.prop,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          scope.row.pol === "CNSHK" &&
                                          _vm.language === "zh"
                                            ? _c("span", [_vm._v("见VGM申报")])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          scope.row.pol === "CNSHK" &&
                                          _vm.language === "en"
                                            ? _c("span", [
                                                _vm._v("See VGM Declare"),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          scope.row.pol !== "CNSHK"
                                            ? _c("span", [
                                                _vm.language === "zh"
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.vgmFlag ===
                                                            "1"
                                                            ? "已维护"
                                                            : "未维护"
                                                        )
                                                      ),
                                                    ])
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.vgmFlag ===
                                                            "1"
                                                            ? "not maintained"
                                                            : "maintained"
                                                        )
                                                      ),
                                                    ]),
                                              ])
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : column.prop === "bookingType2"
                            ? _c("el-table-column", {
                                key: index,
                                attrs: {
                                  sortable: column.sortable,
                                  "show-overflow-tooltip":
                                    column.showOverflowTooltip,
                                  width: column.width,
                                  label: column.label,
                                  prop: column.prop,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          scope.row.separateType === "1"
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.language === "zh"
                                                      ? "分报分出主单"
                                                      : "TOP BL"
                                                  )
                                                ),
                                              ])
                                            : scope.row.separateType === "2"
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.language === "zh"
                                                      ? "分报分出拆单"
                                                      : "SUB BL"
                                                  )
                                                ),
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.showName(
                                                      _vm.bookingType2List,
                                                      scope.row.bookingType2
                                                    )
                                                  )
                                                ),
                                              ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : column.prop === "blType"
                            ? _c("el-table-column", {
                                key: index,
                                attrs: {
                                  sortable: column.sortable,
                                  "show-overflow-tooltip":
                                    column.showOverflowTooltip,
                                  width: column.width,
                                  label: column.label,
                                  prop: column.prop,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          scope.row.separateType === "1" ||
                                          scope.row.separateType === "2"
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.language === "zh"
                                                      ? "拆单"
                                                      : "SPLIT BILL"
                                                  )
                                                ),
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.showName(
                                                      _vm.biTypeList,
                                                      scope.row.blType
                                                    )
                                                  )
                                                ),
                                              ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : column.prop === "tsFlag"
                            ? _c("el-table-column", {
                                key: index,
                                attrs: {
                                  sortable: column.sortable,
                                  "show-overflow-tooltip":
                                    column.showOverflowTooltip,
                                  width: column.width,
                                  label: column.label,
                                  prop: column.prop,
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _vm.language == "zh"
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.tsFlag === "1"
                                                      ? "中转"
                                                      : "直达"
                                                  )
                                                ),
                                              ])
                                            : _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.tsFlag === "1"
                                                      ? "T/S"
                                                      : "Direct"
                                                  )
                                                ),
                                              ]),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            : _c("el-table-column", {
                                key: index,
                                attrs: {
                                  sortable: column.sortable,
                                  "show-overflow-tooltip":
                                    column.showOverflowTooltip,
                                  width: column.width,
                                  label: column.label,
                                  prop: column.prop,
                                },
                              }),
                        ]
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "",
                          label: _vm.$t("home.operate"),
                          width: "230px",
                          fixed: "right",
                          fit: false,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            disabled: scope.row.status !== 10,
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleAddBookingSubmit(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.$t("home.submit")))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        { attrs: { type: "text" } },
                                        [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleLook(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("home.lookOne"))
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        { attrs: { type: "text" } },
                                        [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleLookSupply(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("home.lookOneSupply")
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-dropdown",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            { attrs: { type: "text" } },
                                            [
                                              _vm._v(
                                                "\n            " +
                                                  _vm._s(_vm.$t("home.more")) +
                                                  "\n          "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-dropdown-menu",
                                            {
                                              attrs: { slot: "dropdown" },
                                              on: {
                                                command: _vm.handleCommand,
                                              },
                                              slot: "dropdown",
                                            },
                                            _vm._l(
                                              _vm.operateList,
                                              function (item, index) {
                                                return _c(
                                                  "el-dropdown-item",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.shouldShowItem(
                                                            scope.row,
                                                            index
                                                          ),
                                                        expression:
                                                          "shouldShowItem(scope.row,index)",
                                                      },
                                                    ],
                                                    key: index,
                                                    attrs: {
                                                      disabled:
                                                        ((index === 2 ||
                                                          index === 7) &&
                                                          (scope.row.pol.startsWith(
                                                            "TH"
                                                          ) ||
                                                            (scope.row.por &&
                                                              scope.row.por.startsWith(
                                                                "TH"
                                                              )))) ||
                                                        ((index === 5 ||
                                                          index === 6 ||
                                                          index === 7) &&
                                                          (scope.row.pol ===
                                                            "CNSHK" ||
                                                            scope.row.pol ===
                                                              "CNNSA" ||
                                                            scope.row.pol ===
                                                              "CNYPG")),
                                                    },
                                                    nativeOn: {
                                                      click: function ($event) {
                                                        return _vm.dropdownItemClick(
                                                          scope.row,
                                                          index
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n              " +
                                                        _vm._s(
                                                          _vm.language === "zh"
                                                            ? item.name
                                                            : item.nameEn
                                                        ) +
                                                        "\n            "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2202382011
                        ),
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "sort-box" }, [
                    _c("div", { staticClass: "sort-box-item" }, [
                      _c("i", {
                        staticClass: "el-icon-refresh-left",
                        on: { click: _vm.initData },
                      }),
                      _vm._v(" "),
                      _c("i", {
                        staticClass: "icon iconhuanyuan",
                        on: { click: _vm.handleSortOpen },
                      }),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "p",
                          {
                            staticClass: "boxNumber-right",
                            staticStyle: { display: "inline-block" },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("home.total") + "：" + this.totalCrnt
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("pagination", {
                          staticClass: "pagePanel",
                          staticStyle: { "text-align": "left" },
                          attrs: {
                            total: _vm.total,
                            page: _vm.listQuery.currentPage,
                            limit: _vm.listQuery.pageSize,
                          },
                          on: {
                            "update:page": function ($event) {
                              return _vm.$set(
                                _vm.listQuery,
                                "currentPage",
                                $event
                              )
                            },
                            "update:limit": function ($event) {
                              return _vm.$set(_vm.listQuery, "pageSize", $event)
                            },
                            pagination: _vm.searchFn,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              )
            : _c(
                "div",
                {
                  staticStyle: {
                    height: "calc(100vh - 417px)",
                    overflow: "auto",
                  },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.handleSelectAllChange },
                      model: {
                        value: _vm.selectAll,
                        callback: function ($$v) {
                          _vm.selectAll = $$v
                        },
                        expression: "selectAll",
                      },
                    },
                    [_vm._v("\n        全选\n      ")]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.tableData, function (item, index) {
                    return _c("div", { key: index, staticClass: "card-box" }, [
                      _c(
                        "div",
                        {
                          class: [
                            "card-box-top",
                            { "special-row": item.webCntFlag === "1" },
                          ],
                        },
                        [
                          _c("el-checkbox", {
                            staticStyle: { "margin-right": "18px" },
                            on: {
                              change: function ($event) {
                                return _vm.handleCheckboxChange(index, $event)
                              },
                            },
                            model: {
                              value: _vm.checkedItems[index],
                              callback: function ($$v) {
                                _vm.$set(_vm.checkedItems, index, $$v)
                              },
                              expression: "checkedItems[index]",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "card-box-top-text" }, [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("home.bkNo")) + ":"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.bkNo))]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "card-box-top-text",
                              staticStyle: { "margin-left": "50px" },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("home.blNo")) + ":"),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.blNo))]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.language == "zh"
                            ? _c("div", { staticClass: "card-box-length" }, [
                                _vm._v(
                                  _vm._s(item.tsFlag === "1" ? "中转" : "直达")
                                ),
                              ])
                            : _c("div", { staticClass: "card-box-length" }, [
                                _vm._v(
                                  _vm._s(item.tsFlag === "1" ? "T/S" : "Direct")
                                ),
                              ]),
                          _vm._v(" "),
                          item.status || item.status === 0
                            ? _c(
                                "div",
                                { staticClass: "card-box-status" },
                                [
                                  _c("bookingStatus", {
                                    staticClass: "main-status",
                                    attrs: {
                                      bookingList: _vm.bookingList,
                                      status: item.status,
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card-main" },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 1 } },
                            [
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", { staticClass: "card-main-box" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("home.vesselName")) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.vesselCode))]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 3 } }, [
                                _c("div", { staticClass: "card-main-box" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("home.voyageNo")) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(item.voyageNo) +
                                        _vm._s(item.voyageLeg)
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 4 } }, [
                                _c("div", { staticClass: "card-main-box" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("home.route")) + ":"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(item.serviceLineCode)),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 5 } }, [
                                _c("div", { staticClass: "card-main-box" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("home.pol")) + ":"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.pol))]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", { staticClass: "card-main-box" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("home.departureTimeOne")) +
                                        ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.parseTime(
                                          item.latestEtdPol,
                                          "{y}-{m}-{d} "
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            {
                              staticStyle: { "margin-top": "14px" },
                              attrs: { gutter: 1 },
                            },
                            [
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", { staticClass: "card-main-box" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("home.newDepartureTime")) +
                                        ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.etdLatest))]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 3 } }, [
                                _c("div", { staticClass: "card-main-box" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("home.pod")) + ":"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.pod))]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 4 } }, [
                                _c("div", { staticClass: "card-main-box" }, [
                                  _c("span", [_vm._v("ETA:")]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.eta))]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 5 } }, [
                                _c("div", { staticClass: "card-main-box" }, [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("home.del")) + ":"),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.del))]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", { staticClass: "card-main-box" }, [
                                  _c("span", [_vm._v("VGM:")]),
                                  _vm._v(" "),
                                  item.pol === "CNSHK" && _vm.language === "zh"
                                    ? _c("span", [_vm._v("见VGM申报")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.pol === "CNSHK" && _vm.language === "en"
                                    ? _c("span", [_vm._v("See VGM Declare")])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.pol !== "CNSHK"
                                    ? _c("span", [
                                        _vm.language === "zh"
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  item.vgmFlag === "1"
                                                    ? "已维护"
                                                    : "未维护"
                                                )
                                              ),
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  item.vgmFlag === "1"
                                                    ? "not maintained"
                                                    : "maintained"
                                                )
                                              ),
                                            ]),
                                      ])
                                    : _vm._e(),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            {
                              staticStyle: { "margin-top": "14px" },
                              attrs: { gutter: 1 },
                            },
                            [
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", { staticClass: "card-main-box" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("home.editTime")) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.updateTime))]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 3 } }, [
                                _c("div", { staticClass: "card-main-box" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("home.manifestType")) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.showName(
                                          _vm.bookingType2List,
                                          item.bookingType2
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 4 } }, [
                                _c("div", { staticClass: "card-main-box" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("home.blNoType")) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.showName(
                                          _vm.biTypeList,
                                          item.blType
                                        )
                                      )
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 5 } }, [
                                _c("div", { staticClass: "card-main-box" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("home.totalNo")) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.topBl))]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-col", { attrs: { span: 6 } }, [
                                _c("div", { staticClass: "card-main-box" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("home.boxType")) + ":"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.crnt))]),
                                ]),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-icon-box" }, [
                        _c(
                          "i",
                          {
                            staticClass:
                              "el-icon-folder-checked icon-box-margin",
                            attrs: { disabled: item.status !== 10 },
                            on: {
                              click: function ($event) {
                                return _vm.handleAddBookingSubmit(item)
                              },
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("home.submit")))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "i",
                          { staticClass: "el-icon-edit icon-box-margin" },
                          [
                            _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleLook(item)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("home.lookOne")))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "i",
                          { staticClass: "el-icon-folder-add icon-box-margin" },
                          [
                            _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleLookSupply(item)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("home.lookOneSupply")))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "i",
                          {
                            staticClass:
                              "el-icon-document-copy icon-box-margin",
                            on: {
                              click: function ($event) {
                                return _vm.handleCopyOne(item)
                              },
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("home.copyOne")))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "i",
                          {
                            staticClass:
                              "el-icon-document-copy icon-box-margin",
                            on: {
                              click: function ($event) {
                                return _vm.handleCopyTwo(item)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("home.copySubimtButton"))),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "i",
                          {
                            staticClass: "el-icon-s-check icon-box-margin",
                            on: {
                              click: function ($event) {
                                return _vm.handleOpenFt(item)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("home.ftExport"))),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "i",
                          {
                            staticClass: "el-icon-upload2 icon-box-margin",
                            on: {
                              click: function ($event) {
                                return _vm.handleExport(item)
                              },
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("home.ftapply")))])]
                        ),
                        _vm._v(" "),
                        _c(
                          "i",
                          {
                            staticClass:
                              "el-icon-document-delete icon-box-margin",
                            on: {
                              click: function ($event) {
                                return _vm.saveCancelBookingHeadWebCom(
                                  item.bookingHeadWebComId
                                )
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("home.bookCancel"))),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "i",
                          {
                            staticClass: "el-icon-reading icon-box-margin",
                            on: {
                              click: function ($event) {
                                return _vm.handleOpenNewReport(item, 0, 0)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("home.reportOut"))),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "i",
                          {
                            staticClass: "el-icon-document-add icon-box-margin",
                            on: {
                              click: function ($event) {
                                return _vm.handleOpenNewReport(item, 1, 0)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("home.reportOutOne"))),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "i",
                          {
                            staticClass: "el-icon-document-add icon-box-margin",
                            on: {
                              click: function ($event) {
                                return _vm.handleOpenNewReport(item, 3, 0)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("home.reportOutTwo"))),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "i",
                          {
                            staticClass:
                              "el-icon-folder-checked icon-box-margin",
                            on: {
                              click: function ($event) {
                                return _vm.handleBookMaterialsDetailVerify(item)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("home.feedcheck"))),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "i",
                          {
                            staticClass:
                              "el-icon-document-delete icon-box-margin",
                            on: {
                              click: function ($event) {
                                return _vm.saveWithdrawBookingHeadWebCom(
                                  item.bookingHeadWebComId
                                )
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("home.withdrawal"))),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.showView(item)
                          ? _c(
                              "i",
                              {
                                staticClass: "el-icon-view icon-box-margin",
                                on: {
                                  click: function ($event) {
                                    return _vm.handOpenPrint(item)
                                  },
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("home.viewLook"))),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showViewSo(item)
                          ? _c(
                              "i",
                              {
                                staticClass: "el-icon-view icon-box-margin",
                                on: {
                                  click: function ($event) {
                                    return _vm.handOpenPrintSo(item)
                                  },
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("home.sOView"))),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ])
                  }),
                ],
                2
              ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "sort-box" },
            [
              !_vm.isShow
                ? _c(
                    "p",
                    {
                      staticClass: "boxNumber-right",
                      staticStyle: { display: "inline-block" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("home.total") + "：" + this.totalCrnt)
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isShow
                ? _c("pagination", {
                    staticClass: "pagePanel",
                    staticStyle: { "text-align": "left" },
                    attrs: {
                      total: _vm.total,
                      page: _vm.listQuery.currentPage,
                      limit: _vm.listQuery.pageSize,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.listQuery, "currentPage", $event)
                      },
                      "update:limit": function ($event) {
                        return _vm.$set(_vm.listQuery, "pageSize", $event)
                      },
                      pagination: _vm.searchFn,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("sailSchedule", {
        ref: "sailSchedule",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.sailScheduleDialogVisible,
        },
        on: {
          selectionChange: _vm.selectionChange,
          "update:visible": function ($event) {
            _vm.sailScheduleDialogVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c("vesselVoyage", {
        ref: "vesselVoyage",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          bookingHeadWebId: _vm.bookingHeadWebId,
          visible: _vm.vesselVoyageDialogVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.vesselVoyageDialogVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c("vgmImportDialog", {
        ref: "vgmImportDialog",
        attrs: {
          "destroy-on-close": true,
          width: "40%",
          bookingHeadWebId: _vm.bookingHeadWebId,
          visible: _vm.vgmImportDialogVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.vgmImportDialogVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c("ftDialog", {
        ref: "ftDialog",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          blNo: _vm.blNo,
          pol: _vm.pol,
          visible: _vm.ftDialogVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.ftDialogVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c("newReportsDialog", {
        ref: "newReportsDialog",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          blNo: _vm.blNo,
          newReportData: _vm.newReportData,
          newReportSearchForm: _vm.newReportSearchForm,
          visible: _vm.newReportsDialogVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.newReportsDialogVisible = $event
          },
          handleClose: _vm.handleClose,
          handleGetTable: _vm.handleGetTable,
        },
      }),
      _vm._v(" "),
      _c("copyBook", {
        ref: "copyBook",
        attrs: {
          width: "40%",
          pol: _vm.polCopy,
          copyId: _vm.copyId,
          visible: _vm.copyVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.copyVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c("checkDialog", {
        ref: "checkDialog",
        attrs: { "destroy-on-close": true, width: "70%" },
      }),
      _vm._v(" "),
      _c("selectTemplate", {
        ref: "selectTemplate",
        attrs: { width: "40%", id: _vm.viewMainId, visible: _vm.viewVisible },
        on: {
          "update:visible": function ($event) {
            _vm.viewVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c("importDialog", {
        ref: "importDialog",
        attrs: {
          "destroy-on-close": true,
          width: "40%",
          bookingHeadWebId: _vm.bookingHeadWebId,
          visible: _vm.importDialog,
        },
        on: {
          "update:visible": function ($event) {
            _vm.importDialog = $event
          },
        },
      }),
      _vm._v(" "),
      _c("combinDialog", {
        ref: "combinDialog",
        attrs: {
          mainId: _vm.mainId,
          visible: _vm.combinDialogDialog,
          dataInfo: _vm.dataInfo,
        },
        on: {
          "update:visible": function ($event) {
            _vm.combinDialogDialog = $event
          },
          handleGetTable: _vm.handleGetTable,
        },
      }),
      _vm._v(" "),
      _c("adjustVesselMsg", {
        ref: "adjustVesselMsg",
        attrs: {
          width: "40%",
          adVesselMsg: _vm.adVesselMsg,
          visible: _vm.adjustVesselMsgVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.adjustVesselMsgVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c("cancelBookingListMsg", {
        ref: "cancelBookingListMsg",
        attrs: {
          width: "60%",
          cancelBookingListMsg: _vm.cancelBookingListMsg,
          visible: _vm.cancelBookingListMsgVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.cancelBookingListMsgVisible = $event
          },
        },
      }),
      _vm._v(" "),
      _c("transfer", {
        ref: "transfer",
        attrs: {
          width: "40%",
          targetDataOne: _vm.targetDataOne,
          sourceDataOne: _vm.sourceData,
          visible: _vm.transferDialogVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.transferDialogVisible = $event
          },
          handleSubmitSort: _vm.handleSubmitSort,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }